<ion-header>
  <app-mobile-toolbar *ngIf="appService.isMobile()"></app-mobile-toolbar>
  <app-desktop-header *ngIf="!appService.isMobile()"></app-desktop-header>
</ion-header>
<ion-content #content>
  <main class="flex flex-row items-center justify-center pb-40 pt-80">
    <div class="general-container flex flex-col gap-12">
      <div class="shipping-info-form-container">
        <div class="header-section flex flex-col items-start p-20">
          <h2>Seguimiento de tu pedido.</h2>
          <span
            >Introduce tu número de pedido y correo electrónico para que podamos mostrarte la situación actual de tu
            pedido.</span
          >
        </div>
        <form class="w-100" [formGroup]="shippingInfoForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="orderNumber">Número de pedido <span class="text-red-600">*</span></label>
            <input
              id="orderNumber"
              formControlName="orderNumber"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
              required
              (input)="filterNonNumeric($event)"
            />
            <div
              class="error"
              *ngIf="shippingInfoForm.get('orderNumber')?.invalid && shippingInfoForm.get('orderNumber')?.touched"
            >
              {{ getErrorMessage('orderNumber') }}
            </div>
          </div>

          <div class="form-group">
            <label for="email">Email <span class="text-red-600">*</span></label>
            <input id="email" formControlName="email" type="email" required />
            <div class="error" *ngIf="shippingInfoForm.get('email')?.invalid && shippingInfoForm.get('email')?.touched">
              {{ getErrorMessage('email') }}
            </div>
          </div>

          <ion-button type="submit" color="dark" [disabled]="shippingInfoForm.invalid">Aceptar</ion-button>
          <!-- Mensaje de error de envío -->
          <div *ngIf="submitErrorMessage" class="error">
            {{ submitErrorMessage }}
          </div>
        </form>
      </div>

      <div *ngIf="showTrackingData" class="progress-wrapper">
        <app-client-tracking-data
          [trackingData]="trackingData"
          [order]="order"
          (trackingRefreshed)="scrollToBottom()"
        ></app-client-tracking-data>
      </div>
    </div>
  </main>
</ion-content>
